<ng-container *ngIf="isNewFlowCheckoutPedirDelivery">
  <div class="message-error-dialog" [class.new-design-font]="isNewFlowCheckoutPedirDelivery">
    <p class="message-error-dialog__title">{{header}}</p>
    <div class="message-error-dialog__icon">
      <img [src]="type === 'stock' ? 'assets/icon/close-circle.svg' : 'assets/icon/error-circle.svg'" width="80" height="80" aria-hidden="true" alt="">
    </div>
    <p class="message-error-dialog__text">{{message}}</p>
    <div class="message-error-dialog__actions">
      <button *ngIf="error" class="message-error-dialog__btn-primary" (click)="followOrder()" translate>Ver pedido</button>
      <button *ngIf="!error" class="message-error-dialog__btn-primary" (click)="dismiss()">
        {{ (type === 'stock' ? 'Voltar ao cardápio' : 'Retornar ao carrinho') | translate }}
      </button>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="!isNewFlowCheckoutPedirDelivery">
  <div class="mp-header">
    <div class="mp-toolbar" [class.mp-toolbar--warning]="error" [class.mp-toolbar--danger]="!error" style="text-align: center; padding: 2px;">
        <div class="mp-toolbar__content">
          <div>
            <span class="mp-label ion-text-wrap" style="font-weight: 800; font-size: 16px; padding: 7px;" text-wrap translate>
              {{header}}
            </span>
          </div>
        </div>
    </div>
  </div>

  <div *ngIf="error" style="margin: auto; margin-bottom: 7px; margin-top: 4px;">
    <img src="assets/icon/warning.svg" width="60">
  </div>

  <div *ngIf="!error" style="margin: auto; margin-bottom: 7px; margin-top: 4px;">
    <img src="assets/icon/close.svg" width="60">
  </div>

  <div>
    <p style="text-align: center; font-size: 16px; padding: 0px 30px 0px 30px;" translate>
      {{message}}
    </p>
  </div>

  <div *ngIf="error">
    <button class="mp-button mp-button--ios mp-button--warning mp-button--block" (click)="followOrder()" style="font-weight: 900;" translate>
      View Order
      <mp-icon name="arrow-forward-circle-outline" style="margin-left: 4px; font-size: 27px;"></mp-icon>
    </button>
  </div>

  <div *ngIf="!error">
    <button class="mp-button mp-button--ios mp-button--danger mp-button--block" (click)="dismiss()" style="font-weight: 900;" translate>
      <mp-icon name="checkmark-outline" style="margin-right: 4px;"></mp-icon> OK
    </button>
  </div>
</ng-container>
